import { useCallback } from 'react';
import { setCorrelationContext } from '~/clients';
import { fetchUserProfile } from '~/services/common';
import { logError } from '~/utilities/errorHandlers';

export default function useFetchProfile() {
  return useCallback(async () => {
    try {
      const profile = await fetchUserProfile(new AbortController());
      const { customerId: userId } = profile;
      if (userId) {
        setCorrelationContext(userId);
      }

      return profile;
    } catch (err) {
      logError(err, { location: 'Get User Profile' });
    }
  }, []);
}
